import React from "react";
import { useDispatch } from "react-redux";
import {
  deleteItemInCart,
  increaseQty,
  decreaseQty,
} from "./redux/cart/cartSlice";

function CartItems({ item }) {
  const dispatch = useDispatch();

  return (
    <div className="flex gap-4 bg-white p-4 rounded-xl shadow-md">
      <img
        src={item.img}
        alt={item.title}
        className="w-24 h-24 object-cover rounded-lg"
      />

      <div className="flex-1">
        <h3 className="font-semibold">{item.title}</h3>

        {/* Quantity */}
        <div className="flex items-center gap-3 mt-3">
          <button
            onClick={() => dispatch(decreaseQty(item.id))}
            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300"
          >
            −
          </button>

          <span className="font-semibold">{item.quantity}</span>

          <button
            onClick={() => dispatch(increaseQty(item.id))}
            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300"
          >
            +
          </button>
        </div>
      </div>

      {/* Price & delete */}
      <div className="flex flex-col items-end justify-between">
        <p className="font-bold">
          {item.price * item.quantity} сом
        </p>

        <button
          onClick={() => dispatch(deleteItemInCart(item.id))}
          className="text-gray-400 hover:text-red-500"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default CartItems;
